import React from 'react'
import { IPublishedGraphicBasic } from '../../types/publishedGraphic'
import { SearchListWrapper } from '../../layouts'
import { PublishedGraphicsListItem } from '../SearchPreviewItems'

export interface IPublishedGraphicsList {
  items: IPublishedGraphicBasic[]
}

export const PublishedGraphicsList = ({ items }: IPublishedGraphicsList) => (
  <SearchListWrapper>
    {items.map((pack) => (
      <PublishedGraphicsListItem key={pack.id} {...pack} />
    ))}
  </SearchListWrapper>
)
